import PurchaseSucceeded from './PurchaseSucceeded';
export default PurchaseSucceeded;
